import { createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../../_helpers/fetchWrapper';
import { ErrorMessageHandler, isEmpty } from '../../_helpers/_methods';

export const initialState = {
  loading: false,
  trainees: [],
  totalCount: 0
};

// A slice
const traineesSlice = createSlice({
  name: 'trainees',
  initialState,
  reducers: {
    gettrainees: (state, action) => {
      state.trainees = action.payload.trainees;
      state.totalCount = action.payload.totalCount;
    },
    startLoading: (state) => {
      state.loading = true;
    },

    stopLoading: (state) => {
      state.loading = false;
    }
  }
});

// Actions generated from the slice
const { gettrainees, startLoading, stopLoading } = traineesSlice.actions;

// export user selector to get the slice in any component
export const traineesSelector = (state) => state.trainees;
// export The reducer
const traineesReducer = traineesSlice.reducer;

export default traineesReducer;

// Actions

export const fetchtrainees = (url) => async (dispatch) => {
  try {
    dispatch(startLoading());
    const response = await fetchWrapper.get(url);
    dispatch(gettrainees({ trainees: response.data.results, totalCount: response.data.count }));
    dispatch(stopLoading());
  } catch (error) {
    dispatch(stopLoading());
    console.log(error);
    ErrorMessageHandler(error);
  }
};
export const fetchtrainee = (url) => async (dispatch) => {
  try {
    dispatch(startLoading());
    const response = await fetchWrapper.get(url);

    let data = response.data;

    data.old_office_address = data.office_address;
    data.office_address = !isEmpty(data?.office_address || {}) && {
      address: [data.office_address]
    };

    dispatch(gettrainees({ trainees: data, totalCount: data.count }));
    dispatch(stopLoading());
  } catch (error) {
    dispatch(stopLoading());
    console.log(error);
    ErrorMessageHandler(error);
  }
};
